// extracted by mini-css-extract-plugin
export default {"icon":"SortIcon_icon__PGHTT","icon__unsorted":"SortIcon_icon__unsorted__jwlFn","icon__type":"SortIcon_icon__type__M9Fv2"};